import { Button, Drawer, Input, Space } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ContentStepForm } from 'src/features/programsV2/schemas/contentStepSchema';

import { ProgramFormItem } from '../../ProgramFormItem';

export interface ConfigureModuleProps {
  isOpen: boolean;
  moduleIndex: number;
  onClose: () => void;
}

const ConfigureModule: React.FC<ConfigureModuleProps> = ({
  isOpen,
  onClose,
  moduleIndex,
}) => {
  const { control } = useFormContext<ContentStepForm>();

  const modules = useWatch({
    control,
    name: 'modules',
  });

  const handleSave = () => {
    onClose();
  };

  return (
    <Drawer
      title={
        modules?.[moduleIndex]?.title
          ? `Configurar módulo - ${modules[moduleIndex].title}`
          : 'Configurar módulo'
      }
      width={700}
      onClose={onClose}
      open={isOpen}
      forceRender={true}
      footer={
        <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type='primary' onClick={handleSave}>
            Salvar
          </Button>
        </Space>
      }
    >
      <Space size='middle' direction='vertical' style={{ width: '100%' }}>
        <ProgramFormItem
          control={control}
          name={`modules[${moduleIndex}].title`}
          label='Nome do módulo'
          renderItem={({ field }) => (
            <Input
              {...field}
              placeholder='Ex.: Apresentação'
              style={{ width: '100%' }}
            />
          )}
        />

        <ProgramFormItem
          control={control}
          name={`modules[${moduleIndex}].description`}
          label='Descrição'
          renderItem={({ field }) => (
            <TextArea
              {...field}
              placeholder='Descrição breve da seção...'
              style={{ width: '100%', minHeight: '80px' }}
            />
          )}
        />
      </Space>
    </Drawer>
  );
};

export default ConfigureModule;
